/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Button,
  CustomInput,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  currencyFormatter,
  roundToTwoDecimals,
} from "../../../../_services/currencyFormatter";
import Moment from "react-moment";
import { getDurationInHours } from "../../../Activity/Components/EditActivityModal";
import { api, userService } from "../../../../_services";

const UnassignedActivitiesModal = ({
  showModal,
  toggleModal,
  unassignedActivities,
  setUnassignedActivities,
  invoiceId,
  reload,
}) => {
  const currentUser = userService.getLoggedInUser();
  const [isSaving, setIsSaving] = useState(false);
  const columns = [
    {
      dataField: "activityId",
      text: "Include",
      headerStyle: () => {
        return { width: "5%" };
      },
      formatter: (cellContent, row, i, extraData) => {
        return (
          <CustomInput
            id={`include-${row.activityId}`}
            name={`include-${row.activityId}`}
            type="checkbox"
            checked={!!row.isSelectedToIncludeInInvoice}
            onChange={() => {
              setUnassignedActivities(
                extraData.map((activity) =>
                  activity.activityId === row.activityId
                    ? {
                        ...activity,
                        isSelectedToIncludeInInvoice:
                          !activity.isSelectedToIncludeInInvoice,
                      }
                    : activity,
                ),
              );
            }}
          />
        );
      },
      footer: "",
      formatExtraData: unassignedActivities,
    },
    {
      dataField: "matterName",
      text: "Matter",
      sort: true,
      headerStyle: () => {
        return { width: "15%" };
      },
      footer: "",
    },
    {
      text: "Biller / Rate",
      dataField: "authBillerName",
      sort: true,

      headerStyle: () => {
        return { width: "15%" };
      },
      formatter: (cellContent, row) => {
        return `${row.authBillerName} (${
          row.activityFixedPrice > 0
            ? "Flat Fee " +
              currencyFormatter(
                currentUser.currencySymbol,
                row.activityFixedPrice,
              )
            : currencyFormatter(currentUser.currencySymbol, row.rate) + "/hr"
        })`;
      },
      footer: "",
    },
    {
      dataField: "activityCodeTitle",
      text: "Activity",
      sort: true,
      headerStyle: () => {
        return { width: "15%" };
      },
      //   formatter: (cellContent, row) => {
      //     return (
      //       <a
      //         key={row.activityId}
      //         href="#"
      //         onClick={(e) => {
      //           e.preventDefault();
      //           setActivityToEdit(row);
      //           toggleEditActivityModal();
      //         }}
      //       >
      //         {cellContent}
      //       </a>
      //     );
      //   },
      footer: "",
    },
    {
      dataField: "startTime",
      text: "Date",
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cellContent, row) => {
        return <Moment format="MM/DD/YYYY">{cellContent}</Moment>;
      },
      footer: "",
    },
    {
      dataField: "effectiveDuration",
      text: "Duration",
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cellContent, row) => {
        return getDurationInHours(row.startTime, row.endTime) + " h";
      },
      footer: "",
    },
    {
      dataField: "effectiveCost",
      text: "Amount",
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cellContent, row) => {
        return currencyFormatter(
          currentUser.currencySymbol,
          roundToTwoDecimals(row.effectiveCost),
          true,
        );
      },
      footer: (columnData) =>
        currencyFormatter(
          currentUser.currencySymbol,
          columnData.reduce((acc, item) => acc + item, 0),
          true,
        ),
    },
  ];

  const save = async () => {
    setIsSaving(true);
    var requests = [];
    unassignedActivities
      .filter((x) => x.isSelectedToIncludeInInvoice)
      .forEach((activity) => {
        requests.push(
          api.updateActivity({ ...activity, invoiceId: invoiceId }),
        );
      });
    if (requests.length > 0) {
      await Promise.all(requests);
      reload();
    }
    setIsSaving(false);
    toggleModal();
  };

  return (
    <Modal size="xl" isOpen={showModal} toggle={toggleModal} backdrop="static">
      <ModalHeader toggle={toggleModal}>Unassigned Activities</ModalHeader>
      <ModalBody>
        <p>{unassignedActivities.length} activities are unassigned.</p>
        <Button
          color="primary"
          onClick={() => {
            if (
              unassignedActivities.every((x) => x.isSelectedToIncludeInInvoice)
            ) {
              setUnassignedActivities((prev) =>
                prev.map((x) => ({
                  ...x,
                  isSelectedToIncludeInInvoice: false,
                })),
              );
            } else {
              setUnassignedActivities((prev) =>
                prev.map((x) => ({ ...x, isSelectedToIncludeInInvoice: true })),
              );
            }
          }}
        >
          {unassignedActivities.every((x) => x.isSelectedToIncludeInInvoice)
            ? "Unselect All"
            : "Select All"}
        </Button>
        <BootstrapTable
          bordered={false}
          striped
          responsive
          bootstrap4
          keyField="activityId"
          data={unassignedActivities}
          columns={columns}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="link" onClick={toggleModal}>
          Close
        </Button>
        <Button
          color="primary"
          onClick={save}
          disabled={
            !unassignedActivities.some((x) => x.isSelectedToIncludeInInvoice) ||
            isSaving
          }
        >
          Include Selected in Invoice
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UnassignedActivitiesModal;
